import React, { Component } from 'react'; 
import { connect } from "react-redux";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import moment from 'moment';

import { getLoggedProfile } from "../../model/profile";
import { getBalance, getInvoiceByMonth, withdrawMoney, getRequestWithdraw, updateBankInfo, updateViettelpayInfo } from '../../model/wallet';

import { commonErr } from "../common/errors";
import { TPlatformType } from '../common/common';

import Header from "../common/header"; 
import Sidebar from "../common/sidebar"; 
import Footer from "../common/footer"; 


const withdrawMethods = {
	BANK: 1, 
	VIETTELPAY: 2
}

class WalletItem extends React.Component {
	constructor(props) {
				super(props);
		this.getTotalTrasactionAmount = this.getTotalTrasactionAmount.bind(this);
	}

	getTotalTrasactionAmount(listTransaction){
		var total = 0;
		var i;
		if(listTransaction && listTransaction.length > 0) {
			for (i = 0; i < listTransaction.length; ++i) {
				var transaction = listTransaction[i];
				total += transaction.amount;
			}
		}
		return total;
	}

	render() {
		
		const { platformType, data } = this.props;
		const isBiz = platformType === TPlatformType.BIZ 
		const isAgent = platformType === TPlatformType.AGENT

		return <div>
			<div className="info-display">
				<div className="info-display--item" style={{width: "100%"}}> <span className="highlight">{data.totalTripFinished} </span>
					<p className="desc">Chuyến đi thành công</p>
				</div>
			
			</div>
			<div className="transaction-detail__wrap">
				<div className="transaction-detail__table">
					<div className={`row-transaction main-row ${isBiz? 'biz' : ''}`}>												
						<div className="desc">
							<p>Mã chuyến đi</p>
						</div>
						<div className="desc">
							<p>Hình thức</p>
						</div>
						<div className="desc">
							<p>Ngày đi</p>
						</div>
						<div className="desc">
							<p>Ngày về</p>
						</div>
						<div className="desc">
							<p>Đơn giá thuê</p>
						</div>
						{isAgent ? <div className="desc">
							<p>Tiền thu hộ</p>
						</div> : <div className="desc">
							<p>Phí phát sinh</p>
						</div> }
						{isAgent && <div className="desc">
							<p>Hoa hồng</p>
						</div>}
						<div className="desc">
							<p>Thay đổi số dư</p>
						</div>
					</div>												
					{ data.transactionsFinished && data.transactionsFinished.length > 0 && data.transactionsFinished.map((transaction, index) =>
						<div className={`row-transaction ${isBiz? 'biz' : ''}`}  key={index}>
						<div className="desc"> 
							<p><a href={`/trip/detail/${transaction.trip.id}`} target="_blank">{transaction.trip.id}</a></p>
						</div>
						<div className="desc"> 
								{0 < transaction.trip.serviceType < 2 ? <p>Tự lái</p> : <p>Có tài xế</p>}
						</div>
						<div className="desc"> 
							<p>{moment(transaction.trip.tripDateFrom).format("DD/MM/YYYY")}</p>
						</div>
						<div className="desc"> 
							<p>{moment(transaction.trip.tripDateTo).format("DD/MM/YYYY")}</p>
						</div>
						<div className="desc"> 
							<p><NumberFormat value={transaction.trip.price} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
						</div>
						<div className="desc"> 
							<p><NumberFormat value={transaction.trip.price} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
						</div>
						{isAgent && <div className="desc">
								<p><NumberFormat value={transaction.trip.amount} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
							</div>}
						
						<div className="desc"> 
							<p><NumberFormat value={transaction.amount} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
						</div> 														
					</div>) }
			</div>
			<div className="summary-change">
				<p>Tổng thay đổi - Chuyến đi hoàn thành</p>
				<p><NumberFormat value={this.getTotalTrasactionAmount(data.transactionsFinished)} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
			</div>
			<div className="summary-change">
				<p>Tổng thay đổi - Giao dịch rút/nộp tiền</p>
				<p><NumberFormat value={this.getTotalTrasactionAmount(data.transactionsOther)} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
			</div>
			<div className="summary-change">
				<p>Tổng thay đổi - Giao dịch hủy chuyến</p>
				<p><NumberFormat value={this.getTotalTrasactionAmount(data.transactionsCanceled)} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
			</div>
			<div className="group-summary">
					<div className="transaction-summary">
						<p>TỔNG CỘNG THAY ĐỔI TRONG KÌ</p>
						<p><NumberFormat value={data.endingBalance - data.openingBalance} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
					</div>
					<div className="transaction-summary">
						<p>TIỀN ĐẦU KÌ</p>
						<p><NumberFormat value={data.openingBalance} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
					</div>
					<div className="transaction-summary">
						<p>TIỀN CUỐI KÌ</p>
						<p className="sum-price"><NumberFormat value={data.endingBalance} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
					</div>
				</div>
			</div>
		</div>
	}
}

class MyWallet extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			err: commonErr.INNIT,
			errMsg: "",
			monthInMilliseconds: 0,
			showWithdrawMethod: false, 
			showRegisterVtpay: false, 
			showWithdrawByVtpay: false,
			showWithdrawRequest: false,
			amount: 0,
			accountNumber: "",
			accountName: "",
			bankName: "",
			bankProvince: "",
			bankBranch: "",		
			alertMsg: "",
			withdrawMethod: 1
		}
		
		this.initMonthData = this.initMonthData.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.close = this.close.bind(this);
		this.openWithdrawMethod = this.openWithdrawMethod.bind(this);
		this.closeWithdrawMethod = this.closeWithdrawMethod.bind(this);
		this.openRegisterVtpay = this.openRegisterVtpay.bind(this);
		this.onWithdrawMethodChange = this.onWithdrawMethodChange.bind(this);
		this.onContinueWWithdrawMethod = this.onContinueWWithdrawMethod.bind(this);
		this.openVtPayRequest = this.openVtPayRequest.bind(this);
		this.onRegisterVtpayBtn = this.onRegisterVtpayBtn.bind(this);
		this.cancelRegisterVtpay = this.cancelRegisterVtpay.bind(this);
	}

	componentDidMount() {
		this.refreshCheckFilled();
		this.getWalletInfo(0);
		getLoggedProfile().then(resp => {
			if (resp.data.data && resp.data.data.profile) {
				const profile = resp.data.data.profile;
						this.setState({
							profile: profile,
							phoneNumberRegis: profile.phoneNumber
						});
			} else {
					this.setState({
							showLoginForm: true
					});
			}
		});
	}

	initMonthData(){
		var monthData = [];
		for (var m = moment().startOf('month'); m.isAfter(moment("01/01/2020")); m.subtract(1, 'month')){
			monthData.push({monthInMilliseconds: m.valueOf(), monthInText: m.format("DD-MM-YYYY")});
		}
		monthData.push({monthInMilliseconds: moment("01/01/2020").valueOf(), monthInText: moment("01/01/2020").format("DD-MM-YYYY")});
		return monthData;
	}

	getWalletInfo(monthInMilliseconds){
		var month = monthInMilliseconds > 0 ? monthInMilliseconds : moment().startOf('month').valueOf();
	
		getBalance().then(resp => {
			if (resp.data.error === commonErr.SUCCESS) {
				this.setState({
					balance: resp.data.data.balance,
					amount: resp.data.data.balance,
				})
			} else {
				this.setState({
					err: resp.data.error,
				})
			}
		})
		getInvoiceByMonth(month).then(resp => {
			if (resp.data.error === commonErr.SUCCESS) {

				this.setState({
					monthInMilliseconds: month,
					data: resp.data.data,
					// timeRequested: resp.data.data.timeRequested,
					// accountNumber: resp.data.data.accountNumber && resp.data.data.accountNumber,
					// accountName: resp.data.data.accountName && resp.data.data.accountName,
					// bankName: resp.data.data.bankName && resp.data.data.bankName,
					// bankProvince: resp.data.data.bankProvince && resp.data.data.bankProvince,
					// bankBranch: resp.data.data.bankBranch && resp.data.data.bankBranch,
				})
			} else {
				this.setState({
					err: resp.data.error,
					data: null
				})
			}
		})
		getRequestWithdraw().then(resp => {
			if (resp.data.error === commonErr.SUCCESS) {
				this.setState({
					timeRequested: resp.data.data.timeRequested,
					accountNumber: resp.data.data.bank !== null && resp.data.data.bank.accountNumber ? resp.data.data.bank.accountNumber : "",
					accountName: resp.data.data.bank !== null && resp.data.data.bank.accountName ? resp.data.data.bank.accountName : "",
					bankName: resp.data.data.bank !== null && resp.data.data.bank.bankName ? resp.data.data.bank.bankName : "",
					bankProvince: resp.data.data.bank !== null && resp.data.data.bank.bankProvince ? resp.data.data.bank.bankProvince : "",
					bankBranch: resp.data.data.bank !== null && resp.data.data.bank.bankBranch ? resp.data.data.bank.bankBranch : "",
					vtpay: resp.data.data.viettelPay,
					vtpayTimeRequested: resp.data.data.viettelPay !== null  ? resp.data.data.viettelPay.timeRequested : 0,
					vtpayTimeActived: resp.data.data.viettelPay !== null  ? resp.data.data.viettelPay.timeActived : 0,
					vtPayPhoneNumber: resp.data.data.viettelPay !== null ? resp.data.data.viettelPay.phoneNumber : 0,
					vtPayFullName: resp.data.data.viettelPay !== null ? resp.data.data.viettelPay.fullName : "",
		
				})
			} else {
				this.setState({
					err: resp.data.error,
				})
			}
		})		
	}

	//-- Login 
	
	openLoginForm() {
		this.setState({
				showLoginForm: true
		});
	}

	showLoginForm() {
		this.setState({
				showLoginForm: true
		})
	}

	closeLoginForm() {
		this.setState({
				showLoginForm: false
		})
	}

	getLoggedProfile() {
			this.props.dispatch(getLoggedProfile());
	}


	onSelectMonthChange(event){
		var monthInMilliseconds = event.target.value;
		this.setState({
			monthInMilliseconds: monthInMilliseconds
		})
		this.getWalletInfo(monthInMilliseconds);
	}

	openWithdrawRequest() {
		this.setState({
			showWithdrawRequest: true
		});
	}

	openWithdrawMethod() {
		this.setState({
			showWithdrawMethod: true
		})
	}

	openRegisterVtpay() {
		this.setState({
			showRegisterVtpay: true
		})
	}



	confirmCancelWithdrawRequest() {
		this.setState({
			showConfirmCancelWithdraw: true,
		})
	}

	cancelWithdrawRequest() {
		this.setState({ err: commonErr.LOADING });
		withdrawMoney(true, undefined).then(resp => {
			this.setState({
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
				showConfirmCancelWithdraw: false
			})
		}) 
		this.getWalletInfo(0);
	}

	cancelRegisterVtpay() {
		this.setState({ err: commonErr.LOADING });
		const phoneNumber = this.state.profile.phoneNumber;
		updateViettelpayInfo(true, phoneNumber).then(resp => {
			this.setState({
				err: resp.data.error, 
				errMsg: resp.data.errorMessage, 
				showRegisterVtpay: false,
			})
		})
		this.getWalletInfo(0);
	}

	closeWithdrawRequest() {
		this.setState({
			showWithdrawRequest: false
		});
	}

	closeWithdrawMethod() {
		this.setState({
			showWithdrawMethod: false
		})
	}

	closeRegisterVtpay() {
		this.setState({
			showRegisterVtpay: false
		})
	}

	
	handleInputChange(event) {
		this.setState({
			[event.target.name]: event.target.value
		}, () => this.isValidInfo(this.state.withdrawMethod));
	}

	amountChangedHandler = values => {
		this.setState({ amount: values.value }, () => this.isValidInfo(this.state.withdrawMethod));
	}
	
	refreshCheckFilled(){
		this.setState({
				isAccountNameValid: true,
				isAccountNumberValid: true,
				isAmountValid: true,
				isBankBranchValid: true,
				isBankNameValid: true,
				isBankProvinceValid: true,
				isVtPayPhoneNumberValid: true,
				isVtPayFullNameValid: true,
				isPhoneNUmberRegisValid: true,
				alertMsg: "",
		})
	}
	
	isValidInfo(method){
		this.refreshCheckFilled();
		if (this.state.amount <= 0 || !this.state.amount) {
			this.setState({
				isAmountValid: false,
				alertMsg: "Bạn chưa điền số tiền cần rút"
			})
			return "Bạn chưa điền số tiền cần rút"
		}

		if (this.state.amount > this.state.balance) {
			this.setState({
				isAmountValid: false,
				alertMsg: "Số tiền cần rút vượt quá số dư hiện có"
			})
			return "Số tiền cần rút vượt quá số dư hiện có"
		}

		if(method === withdrawMethods.VIETTELPAY){
			if (this.state.vtPayPhoneNumber === 0 || !this.state.vtPayPhoneNumber){
				this.setState({
					isVtPayPhoneNumberValid: false,
					alertMsg: "Số điện thoại không hợp lệ, vui lòng liên hệ tổng đài MIOTO để được hỗ trợ."
				})
				return "Số điện thoại không hợp lệ, vui lòng liên hệ tổng đài MIOTO để được hỗ trợ."
			}
			if (this.state.vtPayFullName === "" || !this.state.vtPayFullName){
				this.setState({
					isVtPayFullNameValid: false,
					alertMsg: "Họ tên đăng ký không hợp lệ, vui lòng liên hệ tổng đài MIOTO để được hỗ trợ."
				})
				return "Họ tên đăng ký không hợp lệ, vui lòng liên hệ tổng đài MIOTO để được hỗ trợ."
			}

			return "";
		}

		// check valid bank account
		if (this.state.accountNumber === "" || !this.state.accountNumber){
						this.setState({
							isAccountNumberValid: false,
							alertMsg: "Bạn chưa điền số tài khoản"
						})
						return "Bạn chưa điền số tài khoản"
				}

		if (this.state.accountName === "" || !this.state.accountName){
				this.setState({
					isAccountNameValid: false,
					alertMsg: "Bạn chưa điền tên người thụ hưởng"
				})
				return "Bạn chưa điền tên người thụ hưởng"
		}
		
		if (this.state.bankName === "" || !this.state.bankName){
			this.setState({
				isBankNameValid: false,
				alertMsg: "Bạn chưa điền tên ngân hàng thụ hưởng"
			})
			return "Bạn chưa điền tên ngân hàng thụ hưởng"
		}

		if (this.state.bankProvince === "" || !this.state.bankProvince){
			this.setState({
				isBankProvinceValid: false,
				alertMsg: "Bạn chưa điền Tỉnh/Thành phố"
			})
			return "Bạn chưa điền Tỉnh/Thành phố"
		}

		if (this.state.bankBranch === "" || !this.state.bankBranch){
			this.setState({
				isBankBranchValid: false,
				alertMsg: "Bạn chưa điền tên chi nhánh"
			})
			return "Bạn chưa điền tên chi nhánh"
		}
		return "";
	
	}	

	openVtPayRequest() {
		if (this.state.vtpay !== null && this.state.vtpayTimeActived > 0 && this.state.vtPayPhoneNumber !== 0) {
			this.setState({
				showWithdrawRequest: true,
			})
		} else {
			this.setState({
				showRegisterVtpay: true,
			})
		}
	}
	
	onContinueWWithdrawMethod() {
		const withdrawMethod = this.state.withdrawMethod

		switch (withdrawMethod) {
			case withdrawMethods.VIETTELPAY:
				this.closeWithdrawMethod();
				this.openVtPayRequest();
				break;
			case withdrawMethods.BANK:
				this.closeWithdrawMethod();
				this.openWithdrawRequest();
				break;
			default:
				break;
		}

	}

	isValidPhoneRegis() {
		this.refreshCheckFilled()
		if (this.state.phoneNumberRegis === "" || !this.state.phoneNumberRegis){
			this.setState({
				isPhoneNUmberRegisValid: false,
				alertMsg: "Bạn chưa điền số điện thoại đăng ký"
			})
			return "Bạn chưa điền số điện thoại đăng ký"
		}
		return "";
	}

	onRegisPhoneNumberChange(e) {
		this.setState({
			phoneNumberRegis: e.target.value
		}, () => this.isValidPhoneRegis())
	}

	onRegisterVtpayBtn() {

		const phoneNumber = this.state.phoneNumberRegis ;

		this.setState({ err: commonErr.LOADING });

		updateViettelpayInfo(false, phoneNumber).then(resp => {
			this.setState({
				err: resp.data.error, 
				errMsg: resp.data.errorMessage, 
				showRegisterVtpay: false,
			})
			if(resp.data.error == commonErr.SUCCESS){
					this.setState({
							errMsg: this.renderRegisVtpMessage(),
					});
			}
		})

		this.getWalletInfo(0);

	}

	onRequestWithdrawBtn(){
		const message = this.isValidInfo(this.state.withdrawMethod);
		if (message !== "") {
			this.setState({
					err: commonErr.FAIL,
					errMsg: message
			})
		} else {
	
			this.setState({ err: commonErr.LOADING });

			if (this.state.withdrawMethod === withdrawMethods.BANK) {

				const data = {
					accountNumber: this.state.accountNumber,
					accountName: this.state.accountName,
					bankName: this.state.bankName,
					bankProvince: this.state.bankProvince,
					bankBranch: this.state.bankBranch,
				}    

				updateBankInfo(data).then(resp => {
					if (resp.data.err <= commonErr.SUCCESS) {
						this.setState({
							err: resp.data.error,
							errMsg: resp.data.errorMessage,
						})
					}
				})
			}
	
		
			const withdrawInfo = {
				amount: this.state.amount,
				method: this.state.withdrawMethod,
			}

			withdrawMoney(false, withdrawInfo).then(resp => {
					this.setState({
							err: resp.data.error,
							errMsg: resp.data.errorMessage,
							showWithdrawRequest: false
				});
					if(resp.data.error == commonErr.SUCCESS){
							this.setState({
									errMsg: this.renderMessage(),
							});
					}
					else {
							this.setState({
									isSubmittedSuccess: false
							});
					}
			});  
			this.getWalletInfo(0);
		}
	}



	renderRegisVtpMessage() {
		return ( 
			<div className='message-box'>  
					Yêu cầu đang được xử lý!
					<p>Nhân viên Viettel Pay sẽ liên hệ bạn trong thời gian sớm nhất (ước tính từ 1-3 ngày làm việc) để thực hiện tư vấn và tiến hành mở tài khoản!</p>
			</div>
		)
	}

	renderMessage() {
		return <div className="message-box">
						Gửi yêu cầu thành công
						<div className="message-box">  
							<p>Yêu cầu rút tiền đã được gửi đi.</p>
							{this.state.withdrawMethod === withdrawMethods.BANK ? 
								<p>Bộ phận kế toán sẽ tiến hành xử lý yêu cầu rút tiền của bạn trong vòng 3 ngày làm việc tiếp theo (không kể Thứ 7 - Chủ nhật và ngày lễ Tết) kể từ khi yêu cầu được gửi</p>
								: <p>Tiền sẽ được chuyển vào tài khoản ViettelPay của bạn trong ngày làm việc kế tiếp.</p> }	
							<p>Để được hỗ trợ, vui lòng gọi hotline 19009217 (T2-T7, 9AM-6PM).</p>
							<p>Xin cám ơn,</p>
							<p>MIOTO TEAM</p>	
						</div>
				</div>
	}
	
	hideMessageBox() {
				this.setState({
						err: commonErr.INNIT,
						errMsg: ""
				});
	}
	
	close(){
				this.setState({
						showConfirmCancelWithdraw: false
				})
	}

	onWithdrawMethodChange(method) {
		this.setState({
			withdrawMethod: method
		})
	}
	
	buildContentRequestForm() {
		const withdrawMethod = this.state.withdrawMethod
		switch (withdrawMethod) {
			case withdrawMethods.BANK:
				return <div>
					<div className="group">
						<span className="lstitle">NGƯỜI THỤ HƯỞNG</span>
						<div className="line-form">
							<label className="label">Số tài khoản (*)</label>
							<div className={this.state.isAccountNumberValid ? "wrap-input" : "wrap-input has-error-form"}>
								<input placeholder="1247563759505" type="text" name="accountNumber" value={this.state.accountNumber} onChange={this.handleInputChange} />
							</div>
						</div>
						<div className="line-form">
							<label className="label">Tên người thụ hưởng (*)</label>
							<div className={this.state.isAccountNameValid ? "wrap-input" : "wrap-input has-error-form"}>
								<input placeholder="Nguyễn Văn A" type="text" name="accountName" value={this.state.accountName} onChange={this.handleInputChange} />
							</div>
						</div>
					</div>
					<div className="group">
						<span className="lstitle">NGÂN HÀNG THỤ HƯỞNG</span>
						<div className="line-form">
							<label className="label">Ngân hàng thụ hưởng (*)</label>
							<div className={this.state.isBankNameValid ? "wrap-input" : "wrap-input has-error-form"}>
								<input placeholder="Ngân hàng Sacombank" type="text" name="bankName" value={this.state.bankName} onChange={this.handleInputChange} />
							</div>
						</div>
						<div className="line-form">
							<label className="label">Tỉnh/Thành phố (*)</label>
							<div className={this.state.isBankProvinceValid ? "wrap-input" : "wrap-input has-error-form"}>
								<input placeholder="Hồ Chí Minh" type="text" name="bankProvince" value={this.state.bankProvince} onChange={this.handleInputChange} />
							</div>
						</div>
						<div className="line-form">
							<label className="label">Chi nhánh (*)</label>
							<div className={this.state.isBankBranchValid ? "wrap-input" : "wrap-input has-error-form"}>
								<input placeholder="Quận 4" type="text" name="bankBranch" value={this.state.bankBranch} onChange={this.handleInputChange} />
							</div>
						</div>
					</div>
					<div className="group group-inline">
						<span className="lstitle">PHÍ CHUYỂN TIỀN (11,000VND)</span>
					</div>
				</div>
			case withdrawMethods.VIETTELPAY: 
				return 	<div>
									<div className="group">
										<span className="lstitle">SỐ ĐIỆN THOẠI (*)</span>
										<div className="line-form">
											<div className="wrap-input"> 
												<input disabled value={this.state.vtPayPhoneNumber} />
											</div>
										</div>
									</div>
								</div>
			default: 
				return <div className="form-request form-default">
							<p>Có lỗi xảy ra. Vui lòng tải lại trang</p>
					</div>
		}
	}

	render() {

		var monthData = this.initMonthData();	
		var content;
		var timeRequestContent = "";
		const { platformType } = this.props.appInit
		// var btnWithdrawContent = <a onClick={this.openWithdrawMethod} className="btn btn--m btn-primary">Gửi yêu cầu rút tiền</a>;
		if (this.state.err === commonErr.LOADING) {
				content = <div>Loading</div> 
		} else {
			// if(this.state.timeRequested && this.state.timeRequested > 0) {
			// 	btnWithdrawContent = <a onClick={this.confirmCancelWithdrawRequest.bind(this)} className="btn btn--m btn-red">Hủy yêu cầu rút tiền</a>;
			// 	timeRequestContent = <p>Thời gian yêu cầu rút tiền: {moment(this.state.timeRequested).format("DD-MM-YYYY HH:mm")}</p>
			// }
			content = <div className="ibox">
					<div className="owner-report__wrap ibox-body">
						<div className="owner-report--heading d-flex justify-content-between"> 
							<h4 className="title">Bảng tổng hợp giao dịch</h4>
							<div className="line-form"> 
								<div className="wrap-select custom-select--dark">
									<select className="form-control" value={this.state.monthInMilliseconds ? this.state.monthInMilliseconds : monthData[0].monthInMilliseconds} onChange={this.onSelectMonthChange.bind(this)}>
									{ monthData.map(monthObj =>(<option key={monthObj.monthInMilliseconds} value={monthObj.monthInMilliseconds}>Tháng {monthObj.monthInText.slice(3)}</option>)) } 									
									</select>
								</div>
							</div>
						</div>
						<div className="owner-report--body text-center">
							<div className="balance-summary">
								<h3><NumberFormat value={this.state.balance} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></h3>
								<p>Số dư hiện tại </p>
							</div>						
						{this.state.data && <WalletItem platformType={platformType} data={this.state.data} monthInMilliseconds={this.state.monthInMilliseconds}></WalletItem>}
						</div>
						<div className="down-report">
							{/* <label>Tải sao kê chi tiết giao dịch</label>
							<div className="d-flex">
								<button className="btn btn--s btn-default">PDF</button>
								<button className="btn btn--s btn-default">Excel</button>
							</div> */}
							{timeRequestContent}
						</div>
					</div>
		
				
					<div className="wrap-btn report-btn d-flex pb-4 justify-content-center">
						{/* {btnWithdrawContent} */}
						<Link className="btn btn-primary" to={{ pathname: `/mymonthlyreport/${moment(Number(this.state.monthInMilliseconds)).format("MM-YYYY")}` }}>
							Xem Sao kê chi tiết giao dịch
						</Link>
					</div>
			</div>
		}
		
		return <div className="mioto-layout page-wrapper">
		
				<Header />
				<Sidebar />
				<div className="content-wrapper">
					<div className="page-content fade-in-up ">
			
						{content}
				{/* -> Popup Request Withdraw */}
				
						{/* <Modal show={this.state.showWithdrawMethod}
							onHide={this.closeWithdrawMethod.bind(this)}
							dialogClassName="modal-sm modal-dialog modal-withdrawal-gate">
							<Modal.Header closeButton={true} closeLabel={""}>
									<Modal.Title>Chọn phương thức rút tiền</Modal.Title>
							</Modal.Header>
								<Modal.Body>
								<div className="request-container">
									<div className="request-gate">
										<p className="explain">Lựa chọn một trong hai hình thức rút tiền từ ví Mioto</p>
										<div className="d-flex">
											<label className="custom-radio custom-control">
												<input className="custom-control-input" type="radio" name="withdraw_method" onChange={() => this.onWithdrawMethodChange(withdrawMethods.BANK)} checked={this.state.withdrawMethod === withdrawMethods.BANK} />
												<span className="custom-control-indicator" />
												<span className="custom-control-description" />
													<div className="logo-request__item d-flex">
														<div className="logo-request bank"><img src={bank} className="img-fluid" /></div>
														<div className="info-card">
															<p>Chuyển khoản ngân hàng</p>
														</div>
													</div>
											</label>
											<label className="custom-radio custom-control">
												<input className="custom-control-input" type="radio" name="withdraw_method" onChange={() => this.onWithdrawMethodChange(withdrawMethods.VIETTELPAY)} checked={this.state.withdrawMethod === withdrawMethods.VIETTELPAY} />
												<span className="custom-control-indicator" />
												<span className="custom-control-description" />
												<div className="logo-request__item d-flex">
													<div className="logo-request viettel-pay"><img src={vtpay} className="img-fluid" /></div>
													<div className="info-card">
														<p>ViettelPay</p>
													</div>
												</div>
											</label>
									</div>
								</div>
								<div className="wrap-btn textAlign-center">
									<button className="btn btn--m btn-primary" onClick={this.onContinueWWithdrawMethod}>Tiếp tục</button>
								</div>
								<div className="space m"></div>
								</div>
							</Modal.Body>
						</Modal>
					
						<Modal show={this.state.showWithdrawRequest}
								onHide={this.closeWithdrawRequest.bind(this)}
								dialogClassName="modal-sm modal-dialog modal-withdrawal-req">
							<Modal.Header closeButton={true} closeLabel={""}>
									<Modal.Title>Yêu cầu rút tiền</Modal.Title>
							</Modal.Header>
								<Modal.Body>
								<div className="request-container">
									<p>Với trách nhiệm thuộc về Tôi/Chúng tôi, đề nghị Quý Công ty ghi nợ tài khoản của Tôi/Chúng tôi để thực hiện chuyển tiền theo nội dung sau:</p>
									{this.state.alertMsg !== "" && <div className="message-valid-box">
										<p>{this.state.alertMsg}</p>
									</div>}
									
									<div className="form-request form-default">
										<div className="group">
											<span className="lstitle">SỐ TIỀN (*)</span>
											<div className="line-form">
												<div className={this.state.isAmountValid ? "wrap-input" : "wrap-input has-error-form"}> 
												<NumberFormat value={this.state.amount} onValueChange={this.amountChangedHandler} placeholder="Nhập số tiền cần rút" name="amount" thousandSeparator={","}/>
												</div>
											</div>
										</div>
										{this.buildContentRequestForm()}
										<div className="group">
											<a className="btn btn--m btn-request btn-primary" onClick={this.onRequestWithdrawBtn.bind(this)}>Gửi yêu cầu</a>
										</div>
									</div>
								</div>
							</Modal.Body>
						</Modal>
						{/* <MessageBox show={this.state.err <= commonErr.SUCCESS} hideModal={this.hideMessageBox.bind(this)} message={this.state.errMsg} error={this.state.err} /> */}
					
						{/* <Modal show={this.state.showRegisterVtpay}
							onHide={this.closeRegisterVtpay.bind(this)}
							dialogClassName="modal-sm modal-confirm modal-regis-viettelpay">
							<Modal.Header closeButton={true} closeLabel={""}>
									<Modal.Title>Rút tiền nhanh từ ví Mioto với thẻ Viettel Pay!</Modal.Title>
							</Modal.Header>
								<Modal.Body>
								<div className="register-container">
								<div className="register-wrapper">
									<div className="form-default">
											{this.state.alertMsg !== "" && <div className="message-valid-box">
												<p style={{ color: "#c40012", marginBottom: "0px"}}>{this.state.alertMsg}</p>
											</div>}
											<div className="line-form">
											<label>Số điện thoại đăng ký</label>
											<div className={this.state.isPhoneNUmberRegisValid ? "wrap-input" : "wrap-input has-error-form"}>
												{this.state.vtpayTimeRequested === 0 && this.state.vtpayTimeActived === 0 ? <input type="text" value={this.state.phoneNumberRegis} onChange={this.onRegisPhoneNumberChange.bind(this)} /> : <input disabled type="text" value={this.state.phoneNumberRegis} />  }
												</div> 
											</div>
										</div>
										<p>Mioto phối hợp cùng Viettel Pay triển khai tính năng rút tiền nhanh dành cho các đối tác chủ xe Mioto thông qua tài khoản ngân hàng số Viettel Pay, rút ngắn thời gian xử lí trong vòng 1 ngày và tiết kiệm phí giao dịch.</p>
										<div className="benefit-withdraw">
											<h4>Tiện ích từ Mioto</h4>
											<table className="benefit-table">
												<thead>
													<tr>
														<th />
														<th>Viettel Pay</th>
														<th>Chuyển khoản Ngân hàng</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<th>Thời gian xử lí</th>
														<td>1 ngày làm việc</td>
														<td>3 ngày làm việc</td>
													</tr>
													<tr>
														<th>Phí giao dịch</th>
														<td>3,000 VNĐ / giao dịch</td>
														<td>11,000 VNĐ / giao dịch</td>
													</tr>
												</tbody>
											</table>
										</div>
										<div className="benefit-withdraw">
											<h4>Ưu đãi khác từ Viettel Pay</h4>
											<div className="benefit-item__wrap">
												<div className="benefit-item"><i className="ict-benefit ict-bank" />
													<p>Miễn phí chuyển khoản đến 43 ngân hàng</p>
												</div>
												<div className="benefit-item"><i className="ict-benefit ict-withdraw" />
													<p>Miễn phí rút tiền tại tất cả ATM và 200.000 cửa hàng Viettel trên toàn quốc</p>
												</div>
												<div className="benefit-item"><i className="ict-benefit ict-account" />
													<p>Không phí duy trì tài khoản</p>
												</div>
												<div className="benefit-item"><i className="ict-benefit ict-phone-card" />
													<p>Chiết khấu 5% mua thẻ cào, nạp cước điện thoại</p>
												</div>
												<div className="benefit-item"><i className="ict-benefit ict-payment" />
													<p>Hơn 100+ tiện ích thanh toán và mua sắm trên Viettel Pay</p>
												</div>
											</div>
										</div>
										<div className="benefit-footer">
											<p>Tư vấn, cài đặt và mở tài khoản miễn phí - tận nhà bởi nhân viên Viettel.</p>
											<p>Các chủ xe trên ứng dụng có thể đăng kí mở tài khoản ngân hàng số Viettel Pay ngay tại đây !</p>
									</div>
						
									<div className="wrap-btn d-flex">
										{this.state.vtpayTimeRequested === 0 && this.state.vtpayTimeActived === 0 ?
											<a className={this.state.isPhoneNUmberRegisValid ? "btn btn--m btn-primary" : "btn btn--m btn-primary disabled"} onClick={this.onRegisterVtpayBtn}>Đăng ký ngay</a>
											:
											<a className="btn btn--m btn-secondary" onClick={this.cancelRegisterVtpay}>Hủy yêu cầu đang xử lý</a>}
										</div> 
									</div>
								</div>
							</Modal.Body>
						</Modal> */}
					
						{/* <Modal
							show={this.state.showConfirmCancelWithdraw}
							onHide={this.close}
							dialogClassName="modal-sm modal-dialog">
							<Modal.Header closeButton={true} closeLabel={""}>
								<Modal.Title>Thông báo</Modal.Title>
							</Modal.Header>
							<Modal.Body><div className="module-register" style={{ background: "none", padding: "0" }}>
								<div className="form-default form-s">
									<div className="textAlign-center">
										<p style={{ color: '#141414' }}>Bạn muốn hủy yêu cầu rút tiền?</p>
									</div>
									<div className="space m" />
									<div className="space m" />
									<div className="wrap-btn has-2btn">
										<div className="wr-btn">
											<a className="btn btn-secondary btn--m" onClick={this.close}>Bỏ qua</a>
										</div>
										<div className="wr-btn">
											<a className="btn btn-primary btn--m" onClick={this.cancelWithdrawRequest.bind(this)}>Đồng ý</a>
										</div>
									</div>
								</div>
							</div></Modal.Body>
					</Modal> */}
					{/* <Login show={this.state.showLoginForm} showModal={this.openLoginForm.bind(this)} hideModal={this.closeLoginForm.bind(this)} getLoggedProfile={this.getLoggedProfile.bind(this)} /> */}
		
			
			</div>
					<Footer />
				</div>
			</div>
	}
}

function mapState(state) {
	return {
			appInit: state.appInit
	}
}

MyWallet = connect(mapState)(MyWallet)

export default MyWallet;


// WEBPACK FOOTER //
// ./src/components/account/mywallet.js